import { UpperCasePipe } from '@angular/common';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { InfiniteScrollSentinelDirective } from '@company-box/utils';

@Component({
    selector: 'app-pattern-library',
    standalone: true,
    templateUrl: './pattern-library.component.html',
    styleUrls: ['./pattern-library.component.scss'],
    imports: [
    UpperCasePipe,
    InfiniteScrollSentinelDirective
]
})
export class PatternLibraryComponent implements OnInit {

  @Input() patternCollections: any;
  @Input() patterns: any[] = [];

  @Output()
  public hideModal: EventEmitter<any> = new EventEmitter();

  @Output()
  patternSelected: EventEmitter<any> = new EventEmitter();

  @Output()
  loadMore: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  getCollectionPatterns(collectionId: number) {
    return this.patterns.filter((pattern: { collection: { id: number; }; }) => {
      return pattern.collection.id === collectionId;
    });
  }
  public trackByFn(index: any, item: any) {
    if (!item) {
      return null;
    } else {
      return item.id;
    }
  }
  scroll(id: any) {
    const element = window.document.getElementById(id);
    if(element) element.scrollIntoView();
  }

  hide() {
    this.hideModal.emit();
  }

  addPattern(pattern: any) {
    this.patternSelected.emit(pattern);
  }
}
